<template>
  <div class="tdl-audio-player" v-bind:class="{ 'player-simple': simple }">
    <div v-if="disabled" class="player-overlay">{{ disabledCaption }}</div>
    <div v-if="disabledByError" class="player-overlay by-error">{{ disabledByErrorCaption }}</div>
    <div class="player-content">
      <div v-if="hasHeadOptions() && !simple">
        <slot name="headOptions"></slot>
      </div>
      <div class="player-container">
        <div class="player-backdrop" :style="backdropStyle"></div>
        <div class="actions" v-if="hasSlots() && !simple">
          <div class="action left">
            <slot name="left"></slot>
          </div>
          <div name="right" class="action right">
            <slot name="right"></slot>
          </div>
        </div>
        <div class="player">
          <div class="player-load" v-if="status === statusList.Loading">
            <md-spinner v-show="status === statusList.Loading" md-indeterminate></md-spinner>
          </div>
          <div v-else class="player-controls">
            <div v-if="!simple" class="player-control">
              <md-button
                v-if="status === statusList.Playing"
                class="md-icon-button md-primary"
                @click.prevent.native="skip(-10)"
              >
                <md-icon :mdSvg="mdiRewind10"/>
              </md-button>
            </div>
            <div class="player-control">
              <md-button
                class="md-icon-button md-primary play-button"
                aria-label="play"
                @click.prevent.native="playButton"
              >
                <md-icon v-if="status === statusList.Finished" :mdSvg="mdiReplay"/>
                <md-icon v-else-if="status === statusList.Playing" :mdSvg="mdiPauseCircleOutline"/>
                <md-icon v-else-if="status === statusList.Error" :mdSvg="mdiPlayCircleOutline"/>
                <md-icon v-else :mdSvg="mdiPlayCircleOutline"/>
              </md-button>
            </div>
            <div v-if="!simple" class="player-control">
              <md-button
                v-if="status === statusList.Playing"
                class="md-icon-button md-primary"
                @click.prevent.native="skip(10)"
              >
                <md-icon :mdSvg="mdiFastForward10"/>
              </md-button>
            </div>
          </div>
        </div>
        <div class="bottom-actions" v-if="hasBottomSlots() && !simple">
          <div name="bottom-left" class="action left">
            <slot name="bottom-left"></slot>
          </div>
          <div name="bottom-right" class="action right">
            <slot name="bottom-right"></slot>
          </div>
        </div>
      </div>
      <slot name="player-title" v-if="hasPlayerTitleSlot()"></slot>
      <template v-else>
        <a v-if="providerUrl" :href="returnProviderUrl" class="profile-link">
          <div class="player-title" v-if="name && !simple">
            <span>{{ name }}</span>
          </div>
        </a>
        <div v-else>
          <div class="player-title" v-if="name && !simple" @click="titleClick">
            <span>{{ name }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style src="./AudioPlayer.scss" lang="scss"></style>
<script src="./AudioPlayer.mjs"></script>
